<template src="./deactivated.html"></template>

<script>
import { ChiRhosNext } from '@paladin/core'

const ChiRhosNextApi = new ChiRhosNext().api()

export default {
  page() {
    return {
      title: 'Deactivated People',
    }
  },
  components: { },
  props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      people: [],
    }
  },
  mounted: function() {
      this.$nextTick(function() {
        this.init()
    })
  },
  methods: {
    init()
    {
       ChiRhosNextApi.PersonApi.listInactive({
        page: 1
          }).then(
            response => {
              if (response.data) {
                this.people = response.data
              }
            },
            error => {
              console.error(error);
              error.json().then(body => {
                this.$toast(body.Message, "error");
              })
            }
          )

    },
    activate(entityId)
    {
      ChiRhosNextApi.PersonApi.activate({
        entityId
          }).then(
            response => {
                this.$toast("Person activated", "success")
              this.init()
            },
            error => {
              console.error(error);
              error.json().then(body => {
                this.$toast(body.Message, "error");
              })
            }
          )
    }
  },
}
</script>
